<template>
  <div>
    <el-dialog :visible.sync="centerDialogVisible" width="60%" :before-close="el_Callback" :close="disAgreeHabdle" center>
      <div v-html="content" class="agreeList"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="custom-button-active" @click="agreeHandle">已同意相关的协议</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAgreement } from "@/api/index.js";
import util from "@/utils";
export default {
  name: "termList",
  props: {
    type: {
      type: String,
      default: "doctor_reg",
    },
  },
  data () {
    return {
      centerDialogVisible: true,
      content: "",
      user_type: "",
    };
  },
  mounted () {
    this.readyInfo();
  },
  methods: {
    //修改关闭后无法打开的问题
    el_Callback (done) {
      this.centerDialogVisible = false;
      this.$emit("e_Callback");
    },

    // /*获取协议*/
    async readyInfo () {
      try {
        let params = {
          type: this.type,
        };
        let res = await getAgreement(params);
        if (res.success) {
          let dataStr = "ServiceAgreement";
          if (this.user_type === "1") {
            dataStr = "student" + dataStr;
          } else {
            dataStr = "teacher" + dataStr;
          }
          if (res.result.records[0]) {
            this.content = res.result.records[0].content;
          } else {
            this.content = "获取协议为空，请联系管理员到后台添加";
          }
        }
      } catch (error) {
      }
    },
    agreeHandle () {
      // 重置window.opener用来获取打开当前窗口的窗口引用
      // 这里置为null,避免IE下弹出关闭页面确认框
      this.centerDialogVisible = false;
      this.$emit("agreeList");
    },
    disAgreeHabdle () {
      this.$router.push({
        name: "login",
      });
    },
  },
};
</script>

<style scoped>
.agreeList {
  height: 500px;
  border: solid 1px #9999;
  padding: 10px;
  overflow-y: auto;
  overflow-x: hidden;
}
.custom-button-active {
  background: #fc701a !important;
  border: #fc701a !important;
}
</style>
